import ContactsModule from './ContactsModule';

export default ContactsModule;